module.exports = __webpack_public_path__ + "b1087450b2e332e63b1679f8ded5c49e.png";